import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

const URL = 'https://liza.health/fhir/CodeSystem/hoos-jr';

/** System for the HOOS, JR. answer options (the None–Extreme scale the patient picks from). The
 * scored ordinal (0–4) and Spanish display live on the Questionnaire answerOption, not here. HOOS,
 * JR. has no LOINC answer codes, so these are minted in-house. */
export const HOOS_JR_SYSTEM = URL;

const CONCEPTS = [
  { code: 'none', display: 'None' },
  { code: 'mild', display: 'Mild' },
  { code: 'moderate', display: 'Moderate' },
  { code: 'severe', display: 'Severe' },
  { code: 'extreme', display: 'Extreme' },
] as const satisfies CodeSystemConcept[];

export type HoosJrCode = (typeof CONCEPTS)[number]['code'];

export const hoosJrCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: URL,
  name: 'hoos-jr',
  title: 'HOOS, JR.',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
